// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fw","advertDetailContacts__header":"c-n_fx"};